import { z } from 'zod';
import { useIntl } from 'react-intl';

export const useCustomErrorMap = () => {
  const { formatMessage } = useIntl();

  const customErrorMap: z.ZodErrorMap = (issue, ctx) => {
    switch (issue.code) {
      case z.ZodIssueCode.invalid_string:
        if (issue.validation === 'email') {
          return {
            message: formatMessage({
              id: 'form.invalid_email',
              defaultMessage:
                'Måste vara en giltig e-postadress och får endast innehålla a-z, 0-9 samt .+-_',
            }),
          };
        }
        if (issue.validation === 'uuid') {
          return {
            message: formatMessage({
              id: 'form.invalid_uuid',
              defaultMessage: 'Felaktigt ID format',
            }),
          };
        }
        if (issue.validation === 'regex') {
          return {
            message: formatMessage({
              id: 'form.invalid_regex',
              defaultMessage: 'Felaktigt format',
            }),
          };
        }
        break;
      case z.ZodIssueCode.invalid_type:
        if (issue.expected === 'string') {
          if (issue.received === 'undefined') {
            return {
              message: formatMessage({
                id: 'form.invalid_type',
                defaultMessage: 'Fältet är obligatoriskt',
              }),
            };
          }
          return {
            message: formatMessage({
              id: 'form.invalid_type',
              defaultMessage: 'Felaktigt format',
            }),
          };
        }
        break;
      case z.ZodIssueCode.too_small:
        if (issue.minimum === 1) {
          return {
            message: formatMessage({
              id: 'form.required',
              defaultMessage: 'Fältet är obligatoriskt',
            }),
          };
        }
        return {
          message: formatMessage(
            {
              id: 'form.too_small',
              defaultMessage: 'Minst {minimum} tecken',
            },
            {
              minimum: Number(issue.minimum),
            },
          ),
        };
        break;
    }

    return { message: ctx.defaultError };
  };

  return customErrorMap;
};
